module.exports = __webpack_public_path__ + "img/3.ae37c2e0.jpg";